var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEnable)?_c('div',{staticClass:"d-flex align-items-center"},[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),_c('img',{staticClass:"ml-2",attrs:{"src":`assets/img/loader.gif`,"title":"Loading..."}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }